import { Batch } from "@gearbox-protocol/sdk/permissionless";
import { ErrorView, PageLayout } from "@gearbox-protocol/ui-kit";
import { useQuery } from "@tanstack/react-query";
import { ClipboardX } from "lucide-react";
import { ProposalCard } from "@/components/proposals/proposal-card";
import { SkeletonProposalCard } from "@/components/proposals/skeleton-proposal-card";
import { useWeb3 } from "@/hooks/use-web3";
import { fetchGearboxApi } from "@/utils/api-fetch";

export function HistoryPage() {
  const { crossChainMultisig } = useWeb3();

  const {
    data: proposals,
    isLoading,
    error,
  } = useQuery<Batch[], Error>({
    queryKey: ["history-proposals"],
    queryFn: async () => {
      return fetchGearboxApi<Batch[]>("/ccm/proposals", {
        errorMessage: "Failed to fetch proposals",
      });
    },
  });

  if (isLoading) {
    return (
      <PageLayout title="Multisig History">
        <div className="space-y-2">
          {Array.from({ length: 5 }).map((_, index) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: <Allow index as key for indistinguishable rows>
            <SkeletonProposalCard key={index} />
          ))}
        </div>
      </PageLayout>
    );
  }

  if (error) {
    return <ErrorView status={500} message={error.message} />;
  }

  return (
    <PageLayout title="Multisig History">
      {crossChainMultisig === undefined ? (
        <div className="space-y-2">
          {Array.from({ length: 5 }).map((_, index) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: <Allow index as key for indistinguishable rows>
            <SkeletonProposalCard key={index} />
          ))}
        </div>
      ) : !proposals || proposals.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12">
          <ClipboardX className="w-16 h-16 text-muted-foreground mb-4" />
          <p className="text-muted-foreground text-lg">
            No completed proposals
          </p>
        </div>
      ) : (
        <div className="space-y-2">
          {proposals.map(tx => (
            <ProposalCard key={tx.hash} proposal={tx} />
          ))}
        </div>
      )}
    </PageLayout>
  );
}
